import { Grid, RadioGroup, FormControlLabel, Radio, FormHelperText } from '@vapor/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CustomerType, ReferenceCustomerFragment, ReferenceCustomersLookupDocument } from 'src/api/api.generated'
import BaseCustomerLookup from './base/base-customer-lookup'
import { SimpleCustomerLookupOption } from './option/simple-customer-lookup-option'

export type ReferenceCustomerLookupProps = {
  value: ((ReferenceCustomerFragment | { id: string }) & { fromExternal: boolean }) | null
  onChange: (value: ReferenceCustomerFragment | null) => void
  disabled?: boolean
  error?: boolean
  disableEdit?: boolean
  disableCreation?: boolean
  createReceiptZero?: boolean
}
export default function ReferenceCustomerLookup({ value, onChange, disabled, error, disableCreation, disableEdit, createReceiptZero }: ReferenceCustomerLookupProps) {
  const { t } = useTranslation()
  const [type, setType] = useState<CustomerType | null>(value && 'type' in value ? value.type : null)

  useEffect(() => {
    if (value !== null && 'type' in value /* && value.fromExternal */) {
      setType(value.type)
    }
  }, [value?.id ?? null])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <RadioGroup
          row
          onChange={(event) => {
            switch (event.target.value) {
              case CustomerType.PERSON:
                setType(CustomerType.PERSON)
                break
              case CustomerType.COMPANY:
                setType(CustomerType.COMPANY)
                break
            }
          }}
          value={type ?? (value !== null && 'type' in value ? value.type : null)}
        >
          <FormControlLabel value={CustomerType.PERSON} control={<Radio size="small" />} label={t('commons.customer_type.person')} disabled={disabled} />
          {!createReceiptZero && <FormControlLabel value={CustomerType.COMPANY} control={<Radio size="small" />} label={t('commons.customer_type.company')} disabled={disabled} />}
          <FormHelperText error={error}>{error}</FormHelperText>
        </RadioGroup>
      </Grid>
      <Grid item xs={12}>
        <BaseCustomerLookup<ReferenceCustomerFragment> //
          customerType={type || undefined}
          value={value && value.id !== '' ? value : null}
          onChange={(v) => {
            onChange(v)
          }}
          queryDocument={ReferenceCustomersLookupDocument}
          renderOption={(option) => <SimpleCustomerLookupOption option={option} showEmail showPhoneNumber />}
          createAction={disableCreation ? false : !value || value.id === '' ? true : false}
          updateAction={disableEdit ? false : value && value.id ? true : false}
          onCustomerUpserted={(customer) => customer}
          disabled={disabled || !type}
          error={error}
        />
      </Grid>
    </Grid>
  )
}
